<template>
  <div class="info-detail-page">
    <TopTitle title="行业资讯"></TopTitle>
    <div class="content">
      <h3>{{article.title}}</h3>
      <p class="time">{{article.date}}</p>
      <p v-for="item in article.showText">{{item}}</p>
      <div class="show-more" @click="showMore" v-show="showMoreBtn">
        <img :src="iconDown">
        <p>付费查看全文</p>
      </div>
    </div>
    <PaymentQrCode :isShowModel="isShowQrCode" :qrCode="qrCode" :price="price" @showModel="showQrCode"></PaymentQrCode>
  </div>
</template>

<script>
import TopTitle from '../components/TopTitle'
import article from '../data/solutions/outhosp/article'
import iconDown from '../assets/icon/ic-down.png'
import PaymentQrCode from '../components/PaymentQrCode'
import { articleOrder, articlePay } from '../services/http'
import store from "../store";
export default {
  name: "InfoDetail",
  components: {
    TopTitle,
    PaymentQrCode
  },
  data () {
    return {
      iconDown,
      id: null,
      articles: [],
      article: {},
      showMoreBtn: true,
      isShowQrCode: false,
      qrCode: '',
      orderInfo: {},
      timer: null,
      price: null,
    }
  },
  computed: {
    isLogged () {
      return store.getters.isLogged;
    },
    userInfo () {
      return store.getters.userInfo;
    }
  },
  mounted () {
    this.id = this.$route.params.id;
    let argicle = article.argicle;
    argicle.forEach(item => {
      item.showText = item.text.slice(0, Math.floor(item.text.length / 2))
    });
    this.articles = argicle;
    this.article = this.articles.find(item => item.id == this.id);
    this.getArticleOrder();

  },
  beforeDestroy () {
    clearInterval(this.timer);
  },

  methods: {
    getArticleOrder () {
      articleOrder({ article_id: this.id }).then(res => {
        if (res.data.status === 'success') {
          this.orderInfo = res.data.data;
          if (this.orderInfo.paid) {
            clearInterval(this.timer);
            this.showMoreBtn = false;
            this.isShowQrCode = false;
            this.article.showText = this.article.text;
          }
        }
      }).catch(err => {
        console.log(err);
      })
    },
    showMore () {
      if (this.isLogged) {
        let json = {
          article_id: this.id,
          unite_order_id: this.orderInfo.unite_order_id
        };
        articlePay(json).then(res => {
          this.isShowQrCode = true;
          this.qrCode = res.data.data.payInfo;
          this.price = res.data.data.fee;
          this.timer = setInterval(() => {
            this.getArticleOrder();
          }, 1000 * 5)

        })
      } else {
        alert('请登录后付费查看');
      }

    },

    showQrCode (val) {
      this.isShowQrCode = val;
    }
  }


}
</script>

<style scoped lang="less">
.info-detail-page {
  .content {
    max-width: 750px;
    margin: -80px auto 32px;
    background-color: #fff;
    position: relative;
    z-index: 1;
    font-size: 14px;
    padding: 64px 125px 32px;
    h3 {
      font-size: 24px;
      color: #404040;
    }
    .time {
      color: #8c8c8c;
      margin: 16px 0;
    }
    p {
      line-height: 22px;
      color: #404040;
      margin-bottom: 4px;
    }
  }
  .show-more {
    position: relative;
    top: -30px;
    left: 0;
    width: 100%;
    height: 208px;
    text-align: center;
    background: -webkit-linear-gradient(hsla(0, 0%, 100%, 0.5), #fff, #fff);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    img {
      display: block;
      width: 24px;
      height: 24px;
      margin: 0 auto;
    }
    p {
      color: #108ee9;
    }
  }
}
</style>